import React from "react";

import { IgIconButton, IgSelect, IgTextField } from "@intelligems/ig-theme";
import { Grid, MenuItem, SelectChangeEvent } from "@mui/material";
import { theme } from "@src/theme";

import {
  TRAFFIC_CONFIG_FILTER_OPTIONS,
  TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS,
} from "../../../components/targeting/utils/constants";

interface UrlParamFilterProps {
  urlParam?: {
    queryParam?: string | null;
    queryParamValue?: string | null;
    queryParamFilterType?: string | null;
  } | null;
  onReset: () => void;
  onUrlParamChange: (
    value: string,
    key: "queryParam" | "queryParamFilterType" | "queryParamValue"
  ) => void;
}
export const UrlParamFilter = ({
  urlParam,
  onUrlParamChange,
  onReset,
}: UrlParamFilterProps) => {
  return (
    <Grid container direction={"column"}>
      <Grid
        item
        container
        direction={"row"}
        columnSpacing={1}
        // justifyContent={"space-between"}
        alignItems={"center"}
        wrap={"nowrap"}
      >
        <Grid item>
          <IgSelect
            variant={"outlined"}
            // sx={{ width: "160px" }}
            key={`query-param-key`}
            placeholder={"Parameter"}
            value={urlParam?.queryParam || "ig-empty"}
            onChange={(e: SelectChangeEvent<any>) => {
              onUrlParamChange(e.target.value, "queryParam");
            }}
          >
            {Object.entries({
              ...TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS,
            }).map(([key, value]) => (
              <MenuItem key={`query-param-key-${key}`} value={key}>
                {value}
              </MenuItem>
            ))}
          </IgSelect>
        </Grid>
        <Grid item>
          <IgSelect
            variant={"outlined"}
            // sx={{ width: "190px" }}
            value={urlParam?.queryParamFilterType || "ig-empty"}
            onChange={(e) => {
              onUrlParamChange(e.target.value, "queryParamFilterType");
            }}
          >
            <MenuItem value={"ig-empty"} sx={{ display: "none" }}>
              Select
            </MenuItem>
            {Object.entries(TRAFFIC_CONFIG_FILTER_OPTIONS).map(
              ([key, value]) => (
                <MenuItem key={`query-param-filter-${key}`} value={key}>
                  {value}
                </MenuItem>
              )
            )}
          </IgSelect>
        </Grid>
        <Grid item>
          <IgTextField
            placeholder={"Value"}
            value={urlParam?.queryParamValue || ""}
            variant={"outlined"}
            disabled={
              urlParam?.queryParamFilterType === "isNotNull" ||
              urlParam?.queryParamFilterType === "isNull"
            }
            onChange={(e) => {
              onUrlParamChange(e.target.value, "queryParamValue");
            }}
          />
        </Grid>
        <Grid item xs={1}>
          <IgIconButton
            onClick={onReset}
            sx={{ width: "100%" }}
            iconType={"clear"}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
